import { BodyParagraph1 } from '@pay-com/components'
import { ErrorSvg } from 'components/ErrorSvg'
import { isProd } from 'consts'
import { useTranslation } from 'react-i18next'

export const ErrorPage = ({ error }: { error: Error }) => {
  const { t } = useTranslation('errors')

  return (
    <div>
      <section className="sticky top-0 z-10 mb-6 flex h-20 w-full flex-col justify-between border-b border-gray-200 px-4 shadow-secondaryAction">
        <div className="mx-auto flex size-full max-w-6xl flex-col justify-between">
          <div className="flex h-full items-center">
            <div className="font-semibold leading-6 tracking-tight text-blueGray-900 md:text-xl">
              {t('activateYourAccount')}
            </div>
          </div>
        </div>
      </section>

      <div className="m-auto mb-14 h-full max-w-2xl text-center text-blueGray-600">
        <ErrorSvg className="w-full" />
        <BodyParagraph1 className="mt-24">
          {t('somethingWentWrong')}
        </BodyParagraph1>
        <BodyParagraph1>{t('pleaseTryAgainLater')}</BodyParagraph1>
        {!isProd && error.message && (
          <p className="mt-4 text-xs font-medium leading-4 text-red-500">
            {error.message}
          </p>
        )}
      </div>
    </div>
  )
}
